import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=46181a6a&"
import script from "./outbound.vue?vue&type=script&lang=ts&"
export * from "./outbound.vue?vue&type=script&lang=ts&"
import style0 from "./outbound.vue?vue&type=style&index=0&id=46181a6a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports